import { client } from './index';

export interface WhatsappTrialStatus {
  started: boolean;
  active: boolean;
  ended: boolean;
  exhausted: boolean;
  expired: boolean;
  used: number;
  limit: number;
  days_total: number;
  days_remaining: number | null;
  expires_at: string | null;
}

export interface WhatsappBotInfo {
  display_phone_number: string | null;
  wa_link: string | null;
  greeting: string | null;
}

export interface WhatsappUsage {
  period: number;
  responses_count: number;
  messages_sent: number;
  messages_received: number;
  quota: number;
  percent_used: number;
}

export interface WhatsappModuleStatus {
  configured: boolean;
  module_enabled: boolean;
  paid: boolean;
  has_enrollments: boolean;
  current_user_phone: string | null;
  trial: WhatsappTrialStatus;
  bot: WhatsappBotInfo;
  usage: WhatsappUsage | null;
  price_label: string | null;
}

export interface WhatsappEnrollmentUser {
  mobile_user_id: number;
  name: string;
  phone: string | null;
  enabled: boolean;
  enrollment_id: number | null;
  enrollable: boolean;
}

export interface WhatsappResponseRow {
  id: number;
  form_name: string;
  code: string;
  user_name: string | null;
  created_at: string;
}

export interface WhatsappResponsesPage {
  total: number;
  page: number;
  per_page: number;
  responses: WhatsappResponseRow[];
}

async function getModuleStatus() {
  const response = await client.get<WhatsappModuleStatus>('/whatsapp_module_react/status');
  return response.data;
}

async function startTrial(phone: string) {
  const response = await client.post<WhatsappModuleStatus>('/whatsapp_module_react/start_trial', {
    phone,
  });
  return response.data;
}

async function getEnrollments() {
  const response = await client.get<{ users: WhatsappEnrollmentUser[] }>('/whatsapp_enrollments');
  return response.data.users;
}

async function enrollUser(mobileUserId: number) {
  const response = await client.post<{ enrollment_id: number; enabled: boolean }>(
    '/whatsapp_enrollments',
    { mobile_user_id: mobileUserId },
  );
  return response.data;
}

async function unenrollUser(enrollmentId: number) {
  const response = await client.delete<{ enabled: boolean }>(
    `/whatsapp_enrollments/${enrollmentId}`,
  );
  return response.data;
}

async function getResponses(page: number) {
  const response = await client.get<WhatsappResponsesPage>(
    `/whatsapp_module_react/responses?page=${page}`,
  );
  return response.data;
}

export const whatsappApi = {
  getModuleStatus,
  startTrial,
  getEnrollments,
  enrollUser,
  unenrollUser,
  getResponses,
};
